import { CustomScrollbarService } from './../../shared/custom-scrollbar/custom-scrollbar.service';
import { DataEntry } from './../../shared/data-entry.interface';
import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { WebcallsService } from 'src/app/webcalls.service';
import { CommonService } from '../common.service';
import { DataproviderService } from 'src/app/dataprovider.service';
import { ActivatedRoute, Router, ChildrenOutletContexts } from '@angular/router';
import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';
import { TooltipTypesEnum } from './../../shared/tooltip-types.enum';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';

@Component({
  selector: "app-what-to-do",
  templateUrl: "./what-to-do.component.html",
  styleUrls: ["./what-to-do.component.scss", "./what-to-do.component.responsive.scss"],
  host: {
    class: "d-block bg-standard p-b-104"
  }
})
export class WhatToDoComponent implements OnInit {
  title: string = "b2c.IDS_WHATTODO";
  subtitle: string = "b2c.IDS_WHATTODO_SUB";
  showSubtitle: boolean = true;
  showSubtitleInfo: boolean = false;
  question: string = "b2c.IDS_WHATTODO_QUE";
  activePage: string = "whattodo";
  nextPage: string = "";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "IDS_WHATTODO_LABEL";
  //tooltipType: TooltipTypesEnum = TooltipTypesEnum.DISCOVER;

  dataEntries: DataEntry[];

  constructor(
    private ro: Router,
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    public csbs: CustomScrollbarService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      true,
      false,
      true,
      null,
      false,
      false,
      this.eventCategory,
      this.eventLabel,
      false,
      null,
      true,
      this.showSubtitle,
      this.showSubtitleInfo
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(1);
  }

  ngOnInit() {
    this.wsCall();
    this.initSelection();
  }

  initSelection() {
    this.dataEntries = this.ds.getDefaultWhatToDo();
    let selectedDataEntry = this.ds.getWhatToDo();
    if (selectedDataEntry) {
      this.onSelectorClicked(selectedDataEntry.ID);
    }
  }

  dataEntriesUpdate(idSelected: number) {
    /* single selection */
    for (let data of this.dataEntries) {
      if (data.ID == idSelected) {
        data.checked = true;
      } else {
        data.checked = false;
      }
    }
    this.cs.updateNextBtn(true);
  }

  onSelectorClicked(idSelected: number) {
    let dataEntry: DataEntry = this.dataEntries.find(d => {
      return d.ID == idSelected;
    });
    if (dataEntry) {
      this.dataEntriesUpdate(idSelected);
      if (idSelected == 1 || idSelected == 2) {
        this.nextPage = "rooms";
        this.ds.setWhatToDo(dataEntry);
      } else if (idSelected == 3) {
        this.nextPage = "havingbticino";
        this.ds.setWhatToDo(dataEntry);
      } else {
        this.nextPage = "rooms";
        this.ds.setWhatToDo(dataEntry);
      }

      this.cs.updateNextPage(this.nextPage);
    } else {
      console.error("data entry not found");
    }

    let listChooise: [{ key: string; value: number; }];
    listChooise = this.cs.getOtherInfoFromSelector(this.dataEntries,idSelected,'STEP_0_');
    this.cs.setGASelectionEvent('step_0',listChooise);
  }

  wsCall() {
    var that = this;
    /* preload data next steps: Housing types */
    this.ws.getHousingTypes().subscribe(data => {
      if (Array.isArray(data)) {
        that.ds.setHousingTypes(data);
      }
    });
    /* preload data next steps: Distinct rooms */

    if (this.ds.getCachedRooms() == undefined || this.ds.getCachedRooms().length == 0){
      this.ws
        .getListOfDistinctRoomTypes(this.ds.getLocalizationID())
        .subscribe(data => {
          if (Array.isArray(data)) {
            this.ds.setCachedRooms(data);
          }
        });
    }
  }

}
